import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { liveQuery } from 'dexie';
import { appDb } from 'dexie/app.db';
import { from, catchError, throwError, switchMap } from 'rxjs';
import { DBService } from './db.service';
import { FileService } from './file.service';
import { ErrorElementsApiService } from './api/error-elements-api.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorElementsService {
  protected dbService = inject(DBService);
  protected fileService = inject(FileService);
  protected errorElementsApiService = inject(ErrorElementsApiService);

  getList(filter?: any) {
    let dbQuery = appDb.errorElement.where('isDeleted').equals(0);
    if (filter?.name) {
      dbQuery = dbQuery.and((item) =>
        item.name.toLowerCase().includes(filter.name.toLowerCase())
      );
    }
    return from(liveQuery(() => dbQuery.sortBy('order')));
  }

  getElementsWithIds(ids: Array<string>) {
    return from(
      liveQuery(() => appDb.errorElement.where('id').anyOf(ids).toArray())
    );
  }

  get(id: string) {
    return from(liveQuery(() => appDb.errorElement.get(id)));
  }

  create(data) {
    return this.errorElementsApiService.create(data).pipe(
      catchError((err: HttpErrorResponse) => {
        if (!navigator.onLine) {
          return this.dbService.createRow(appDb.errorElement, {
            ...data,
            isSynced: 0,
            isDeleted: 0,
          });
        }
        return throwError(() => err);
      })
    );
  }

  update(id, data) {
    return this.errorElementsApiService
      .update(id, {
        id,
        name: data.name,
        order: data.order,
        errorElementDirections: data.errorElementDirections || [],
      })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          if (!navigator.onLine) {
            return this.dbService.updateRow(appDb.errorElement, {
              ...data,
              isSynced: 0,
              isDeleted: 0,
            });
          }
          return throwError(() => err);
        })
      );
  }

  delete(id: string) {
    return this.errorElementsApiService.delete(id).pipe(
      switchMap((res: any) => this.dbService.deleteRow(appDb.errorElement, id)),
      catchError((err: HttpErrorResponse) => {
        if (!navigator.onLine) {
          return this.dbService.updateRow(appDb.errorElement, {
            id,
            isDeleted: 1,
            isSynced: 0,
          });
        }
        return throwError(err);
      })
    );
  }
  getNotSyncedItems() {
    return from(appDb.errorElement.where('isSynced').equals(0).toArray());
  }

  getNotSyncedItemsCount() {
    return from(
      liveQuery(() => appDb.errorElement.where('isSynced').equals(0).count())
    );
  }
  bulkUpdateLocal(items) {
    return from(appDb.errorElement.bulkPut(items));
  }
}
